import { IProject } from 'shared/interfaces'

export const useProjectParent = (project: IProject) => project?.parent || null
